import {
  MODULE_IDS,
  SETTINGS_SECTION_IDS,
  type MemberPermissionOverrides
} from '@finvox/shared/member-access';
import { parseCashbookPermissionOverrides } from '@finvox/shared/cashbook-access';

function parseBooleanMap<T extends string>(
  raw: Record<string, boolean> | undefined,
  allowed: readonly T[]
): Partial<Record<T, boolean>> | undefined {
  if (!raw) return undefined;
  const out: Partial<Record<T, boolean>> = {};
  for (const key of allowed) {
    if (typeof raw[key] === 'boolean') out[key] = raw[key];
  }
  return Object.keys(out).length ? out : undefined;
}

export function normalizeMemberPermissionPayload(
  permissions: MemberPermissionOverrides | null | undefined
): Record<string, unknown> | null {
  if (!permissions) return null;
  const modules = parseBooleanMap(permissions.modules, MODULE_IDS);
  const settings = parseBooleanMap(permissions.settings, SETTINGS_SECTION_IDS);
  const cashbook = parseCashbookPermissionOverrides(permissions.cashbook);
  const normalized: Record<string, unknown> = {};
  if (modules) normalized.modules = modules;
  if (settings) normalized.settings = settings;
  if (cashbook) normalized.cashbook = cashbook;
  if (!Object.keys(normalized).length) return null;
  return normalized;
}
